// src/utils/treeUtils.ts

export type NodeType = {
    id: string;
    name: string;
    types: "dir" | "file";
    fk_videosubmodule_id: string | null;
    fk_videoModule_id: string;
    children?: NodeType[];
  };
  
  export type TreeWrapper = {
    module: string;
    treeData: NodeType[];
  };
  
  export function buildTree(data: NodeType[]): NodeType[] {
    const idToNodeMap: { [key: string]: NodeType } = {};
    const root: NodeType[] = [];
  
    data.forEach((node) => {
      idToNodeMap[node.id] = { ...node, children: [] };
    });
  
    data.forEach((node) => {
      if (node.fk_videosubmodule_id) {
        const parent = idToNodeMap[node.fk_videosubmodule_id];
        if (parent) {
          parent.children?.push(idToNodeMap[node.id]);
        }
      } else {
        root.push(idToNodeMap[node.id]);
      }
    });
  
    return root;
  }
  